import { render, staticRenderFns } from "./CalendarEventCard.vue?vue&type=template&id=79158698&scoped=true&lang=pug"
import script from "./CalendarEventCard.vue?vue&type=script&lang=ts"
export * from "./CalendarEventCard.vue?vue&type=script&lang=ts"
import style0 from "./CalendarEventCard.vue?vue&type=style&index=0&id=79158698&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79158698",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
